import { createListenerMiddleware } from '@reduxjs/toolkit';
import { isOfflineEnabled } from '../../db/odin-db-util';
import type { AppDispatch, RootState } from '../store';
import { networkOnline, processOfflineMutations } from './offline-mutations.thunk';

/**
 * Redux listener middleware instance for handling action-based side effects.
 * Created using Redux Toolkit's `createListenerMiddleware()`.
 *
 * @type {ListenerMiddleware}
 */
export const listenerMiddleware = createListenerMiddleware();

/**
 * Typed version of Redux Toolkit's `startListening` middleware function.
 * Used to set up listener middleware with correct type inference for the application's
 * root state and dispatch types.
 *
 * @type {Function}
 * @typeParam RootState - The type of the root state
 * @typeParam AppDispatch - The type of the app dispatch function
 */
const startAppListening = listenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

// Listen for the browser coming back online
startAppListening({
  actionCreator: networkOnline,
  effect: async (_, { dispatch, cancelActiveListeners, delay }) => {
    if (!isOfflineEnabled) {
      return;
    }

    // Cancel any ongoing processing to avoid conflicts
    cancelActiveListeners();

    // Delay to ensure stable connection
    await delay(5_000);

    // trigger the sync
    dispatch(processOfflineMutations());
  },
});
